import {
  RiFacebookBoxFill,
  RiTwitterXFill,
  RiInstagramLine,
  RiLinkedinBoxFill,
} from "react-icons/ri";
import { Navigate, Outlet } from "react-router";
import Social1 from "../Assets/images/static/Social/1.png";
import Social2 from "../Assets/images/static/Social/2.png";
import Social3 from "../Assets/images/static/Social/3.png";
import Social7 from "../Assets/images/static/Social/7.png";
import { useSelector } from "react-redux";
//-------------------------------------------------url
export const base_url = "https://montgomery-jewelers.com/webapi/api";
export const img_url = "https://montgomery-jewelers.com";
export const helmet_url = "https://montgomery-jewelers.com";
export const is_paypal = false;
export const is_square = false;
export const Je_welryspelling = "Jewelry";
// ------Contact Details Start ------
export const contact_number = {
  // <===---contact Number //
  text: "+1 (714) 374-4517",
  link: `tel:+17143744517`,
  chat: "+17143744517",
};

export const Email_details = {
  // <===---Email_Details  //
  text: "chase@montgomery-jewelers.com",
  link: `mailto:chase@montgomery-jewelers.com`,
};

export const Email_detailsSecond = {
  // <===---Second_Email_details  //
  text: "chase@montgomery-jewelers.com",
  link: `mailto:chase@montgomery-jewelers.com`,
};

export const Address_details = {
  // <===---Address_details  //
  textLine1: "501 Main St # G, Huntington Beach,",
  textLine2: " CA, United States",
  link: "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d106266.92158849155!2d-118.08152139682959!3d33.661273763657285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x80dd2146ce9619db%3A0x586ff0c1da9a266!2s501%20Main%20St%20%23%20G%2C%20Huntington%20Beach%2C%20CA%2092648%2C%20United%20States!3m2!1d33.661301099999996!2d-117.9991202!5e0!3m2!1sen!2sin!4v1733222117812!5m2!1sen!2sin",
};

export const client_name = {
  // <===---client_name  //
  c_name: "Montgomery Jewelers",
};
const facebookIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 0C20.1804 0 26 5.85501 26 13.0792C26 19.6086 21.2469 25.019 15.0313 26V16.8599L18.0604 16.8599L18.0604 16.8599L18.6367 13.0792H18.6367H15.0313V10.6268C15.0313 9.7216 15.4162 8.83589 16.5942 8.62859C16.7625 8.59898 16.947 8.58321 17.1488 8.58321C17.1488 8.58321 17.1489 8.58321 17.1489 8.58321L18.7891 8.58321L18.7891 8.58321V5.36451C18.7891 5.36451 18.7891 5.36451 18.7891 5.36451C18.7891 5.36451 17.3012 5.10906 15.8793 5.10906C15.1243 5.10906 14.4358 5.22605 13.8289 5.45437C12.0479 6.1244 10.9688 7.75319 10.9688 10.1977V13.0792H7.66797H7.66794V16.8599L7.66797 16.8599L10.9688 16.8599V26C4.75312 25.0191 0 19.6086 0 13.0792C0 5.85501 5.81956 0 13 0Z" /></svg>;

const instagramIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM5.2 9.84732C5.2 7.28478 7.28478 5.2 9.84732 5.2H16.1527C18.7152 5.2 20.8 7.28478 20.8 9.84732V16.1527C20.8 18.7152 18.7152 20.8 16.1527 20.8H9.84732C7.28478 20.8 5.2 18.7152 5.2 16.1527V9.84732ZM16.1527 19.2306C17.8526 19.2306 19.2306 17.8526 19.2306 16.1527V9.84732C19.2306 8.1474 17.8526 6.76936 16.1527 6.76936H9.84732C8.14743 6.76936 6.76936 8.1474 6.76936 9.84732V16.1527C6.76936 17.8526 8.14743 19.2306 9.84732 19.2306H16.1527ZM18.0093 8.99558C18.0093 9.52953 17.5765 9.96238 17.0425 9.96238C16.5086 9.96238 16.0757 9.52953 16.0757 8.99558C16.0757 8.46163 16.5086 8.02878 17.0425 8.02878C17.5765 8.02878 18.0093 8.46163 18.0093 8.99558ZM13 8.96528C10.7753 8.96528 8.96528 10.7753 8.96528 13C8.96528 15.2247 10.7753 17.0347 13 17.0347C15.2247 17.0347 17.0347 15.2247 17.0347 13C17.0347 10.7752 15.2247 8.96528 13 8.96528ZM13 15.4654C11.6384 15.4654 10.5346 14.3616 10.5346 13C10.5346 11.6384 11.6384 10.5346 13 10.5346C14.3616 10.5346 15.4654 11.6384 15.4654 13C15.4654 14.3616 14.3616 15.4654 13 15.4654Z" /></svg>;

const twitterIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0ZM12.8085 10.5205L12.7747 9.95822C12.6732 8.50087 13.5637 7.16974 14.9727 6.65335C15.4912 6.46975 16.3704 6.4468 16.9453 6.60745C17.1707 6.67631 17.599 6.90581 17.9034 7.11236L18.4557 7.49105L19.0644 7.29597C19.4025 7.19269 19.8534 7.02056 20.0563 6.90581C20.2479 6.80253 20.417 6.74516 20.417 6.77958C20.417 6.97466 20 7.64022 19.6505 8.00743C19.1771 8.52382 19.3124 8.56972 20.2705 8.22546C20.8453 8.03038 20.8566 8.03038 20.7439 8.24841C20.6763 8.36316 20.3268 8.7648 19.9549 9.13201C19.3236 9.76314 19.2898 9.832 19.2898 10.3599C19.2898 11.1746 18.9066 12.8729 18.5233 13.8024C17.8132 15.5467 16.2915 17.3483 14.7698 18.2548C12.6282 19.5286 9.77637 19.8499 7.37547 19.104C6.57517 18.8515 5.2 18.2089 5.2 18.0942C5.2 18.0597 5.61706 18.0138 6.12429 18.0024C7.18385 17.9794 8.2434 17.6811 9.14515 17.1532L9.75383 16.786L9.05498 16.545C8.06305 16.2008 7.17258 15.409 6.94714 14.6631C6.87951 14.4221 6.90205 14.4106 7.53327 14.4106L8.18704 14.3991L7.63472 14.1352C6.98095 13.8024 6.38354 13.2401 6.09048 12.6664C5.87631 12.2533 5.60579 11.209 5.68469 11.1287C5.70723 11.0943 5.94394 11.1631 6.21447 11.2549C6.99223 11.5418 7.09367 11.473 6.6428 10.991C5.79741 10.1189 5.53816 8.82217 5.94394 7.59432L6.13556 7.04351L6.87951 7.7894C8.40121 9.29266 10.1934 10.1877 12.2449 10.4517L12.8085 10.5205Z" />
</svg>

const yelpIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM7.887 7.03795C8.72617 9.00196 10.3502 11.1251 12.0177 12.496C12.0429 12.5249 12.0683 12.5466 12.0971 12.5647C12.1129 12.577 12.1279 12.5901 12.1423 12.6028L12.1424 12.6028C12.1578 12.6164 12.1727 12.6295 12.1876 12.6407C12.3829 12.7962 12.7265 12.6335 12.6686 12.4056C12.9454 11.9793 12.9087 11.2945 12.8778 10.7193L12.8778 10.7193C12.8684 10.5429 12.8595 10.3769 12.8603 10.2318C12.8712 8.76687 12.8061 7.29836 12.665 5.84074C12.495 4.14796 11.8223 3.66327 10.1295 4.22032C8.87445 4.63265 7.24677 5.54411 7.887 7.03795ZM17.5047 9.37095L17.5045 9.37078C17.3598 9.24784 17.1898 9.24057 17.0487 9.29834C16.9764 9.28745 16.8932 9.30189 16.8244 9.35618C16.0484 9.97568 15.3827 10.7609 14.7371 11.5224L14.5711 11.7181C14.5389 11.7554 14.506 11.7931 14.4727 11.8313L14.4726 11.8314C14.1537 12.1972 13.7965 12.6069 13.6885 13.0817C13.3864 14.4303 15.0043 14.102 15.7766 13.9453L15.79 13.9426C16.7376 13.7509 17.6708 13.4905 18.5787 13.1613C18.6143 13.1483 18.6511 13.1352 18.6886 13.1218C19.0658 12.9873 19.5168 12.8266 19.6385 12.4054C19.9279 11.3747 18.1523 9.90644 17.5047 9.37095ZM15.233 18.3844C15.5802 19.0137 15.9818 19.7335 16.5496 20.1929C16.6546 20.2761 16.7739 20.3014 16.8969 20.2363C16.9187 20.2266 16.9405 20.2153 16.9611 20.2045C16.9714 20.1992 16.9814 20.194 16.991 20.1892L17.0018 20.1784C17.0067 20.1784 17.0117 20.1788 17.0165 20.1793L17.0165 20.1793C17.0258 20.1801 17.0345 20.1808 17.0416 20.1784C18.0724 20.0192 19.3058 18.7714 19.5047 17.7478C19.7013 16.7141 18.276 16.3207 17.3185 16.0565L17.3184 16.0565L17.3184 16.0565L17.3184 16.0565L17.3182 16.0564C17.1133 15.9999 16.9299 15.9493 16.7883 15.8995C16.7435 15.884 16.6904 15.8647 16.6305 15.8431L16.6304 15.843C15.8846 15.573 14.0966 14.9258 14.2673 16.2685C14.342 16.8514 14.7207 17.5012 15.0419 18.0522L15.042 18.0523C15.1093 18.1679 15.1741 18.2791 15.233 18.3844ZM11.8513 16.4601C12.9943 15.9863 13.0992 17.263 13.0919 18.0371C13.0811 18.9594 13.0522 19.8853 12.9834 20.8041C12.9808 20.8427 12.9786 20.8821 12.9764 20.9221L12.9764 20.9221C12.9571 21.2674 12.9359 21.6495 12.6181 21.8602C12.1805 22.1496 11.3378 21.9217 10.8856 21.7807C10.8711 21.7734 10.8566 21.7662 10.8422 21.7626C9.89095 21.5963 8.72989 21.1586 8.61776 20.2797C8.60687 20.1784 8.64672 20.088 8.70819 20.0193C8.73715 19.965 8.76604 19.9144 8.79863 19.8673C8.92947 19.6862 9.0789 19.5238 9.22975 19.3598L9.22976 19.3598L9.26525 19.3212C9.5401 18.9125 9.83674 18.5182 10.1514 18.1384C10.2355 18.0369 10.3232 17.9254 10.4145 17.8091L10.4146 17.8091C10.8182 17.2954 11.2939 16.6901 11.8513 16.4601ZM11.8368 14.6192C11.9706 15.2124 11.551 15.4511 11.0591 15.6754C10.1838 16.0696 9.26511 16.3843 8.34276 16.6448C8.26127 16.6673 8.17315 16.6947 8.0805 16.7234L8.08046 16.7235C7.56445 16.8836 6.90765 17.0875 6.46919 16.7533C6.10118 16.4739 6.05739 15.9087 6.02333 15.4692L6.01709 15.3896C5.93755 14.3877 6.08945 11.9969 7.47834 11.8956C8.04363 11.8565 8.72639 12.2699 9.26068 12.5933L9.26069 12.5933C9.36911 12.659 9.47141 12.7209 9.56538 12.7746C10.3069 13.2014 11.1026 13.6897 11.656 14.3589C11.7391 14.4058 11.8078 14.489 11.8368 14.6192Z" />
</svg>

const linkedinIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13 0C5.82024 0 0 5.82025 0 13C0 20.1797 5.82024 26 13 26C20.1797 26 26 20.1797 26 13C25.9999 5.82025 20.1796 0 13 0ZM9.53156 19.2849H6.67728V10.0635H9.53156V19.2849ZM8.09082 8.85592C7.15864 8.85592 6.40295 8.09407 6.40295 7.15443C6.40295 6.21468 7.15874 5.45287 8.09082 5.45287C9.02289 5.45287 9.77858 6.21468 9.77858 7.15443C9.77863 8.09412 9.02294 8.85592 8.09082 8.85592ZM20.228 19.2849H17.3875V14.4444C17.3875 13.1169 16.8832 12.3758 15.8335 12.3758C14.691 12.3758 14.0941 13.1476 14.0941 14.4444V19.2849H11.3565V10.0635H14.0941V11.3055C14.0941 11.3055 14.9176 9.78225 16.8729 9.78225C18.8283 9.78225 20.228 10.9762 20.228 13.4461L20.228 19.2849Z" />
</svg>


const pintrestIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM3.9 12.9925C3.9 7.97105 7.97775 3.9 13.0075 3.9C18.0372 3.9 22.115 7.97105 22.1 13.0075C22.1 18.0289 18.0222 22.1 12.9925 22.1C12.048 22.1 11.1485 21.9578 10.294 21.6959C10.6688 21.0897 11.2235 20.1019 11.4258 19.3086C11.5383 18.8821 11.9955 17.1459 11.9955 17.1459C12.2879 17.7146 13.1574 18.1936 14.0794 18.1936C16.8229 18.1936 18.8018 15.6716 18.8018 12.536C18.8018 9.52763 16.3431 7.28257 13.1874 7.28257C9.25205 7.28257 7.1682 9.91678 7.1682 12.783C7.1682 14.1225 7.8803 15.7764 9.01968 16.3077C9.19208 16.39 9.28953 16.3526 9.32701 16.188C9.33945 16.1352 9.37386 15.9972 9.41468 15.8336C9.47219 15.6031 9.54241 15.3216 9.58187 15.1553C9.60435 15.0655 9.59686 14.9831 9.5219 14.8933C9.14711 14.4368 8.84727 13.5987 8.84727 12.8204C8.84727 10.8148 10.3689 8.87656 12.9625 8.87656C15.2038 8.87656 16.7704 10.3957 16.7704 12.5734C16.7704 15.028 15.5261 16.7343 13.907 16.7343C13.015 16.7343 12.3403 15.9934 12.5577 15.0879C12.6511 14.7016 12.774 14.3048 12.8935 13.9189C13.1096 13.2209 13.3148 12.5583 13.3148 12.0571C13.3148 11.3611 12.94 10.7774 12.1604 10.7774C11.2459 10.7774 10.5114 11.7203 10.5114 12.985C10.5114 13.7858 10.7812 14.3321 10.7812 14.3321C10.7812 14.3321 9.8817 18.1412 9.71679 18.8521C9.53689 19.6379 9.60435 20.7455 9.68681 21.4639C6.29868 20.1393 3.9 16.8465 3.9 12.9925Z" /></svg>

export const media_details = [
  // <===---media_details  //
  {
    account_alt: "Facbook",
    account_icon: facebookIcon,
    account_img: Social1,
    account_link: "https://www.facebook.com/MontgomeryJewelry/",
  },
  {
    account_alt: "Instgram",
    account_icon: instagramIcon,
    account_img: Social2,
    account_link: "https://www.instagram.com/explore/locations/960416050/montgomery-jewelers/",
  },
  // {
  //   account_alt: "Twitter",
  //   account_icon: twitterIcon,
  //   account_img: Social7,
  //   account_link: "https://twitter.com/belgiumwebnet",
  // },
  // {
  //   account_alt: "Pintrest",
  //   account_icon: pintrestIcon,
  //   account_img: Social3,
  //   account_link: "https://www.pintrest.com/company/belgium-webnet/",
  // },
  {
    account_alt: "Yelp",
    account_icon: yelpIcon,
    account_img: Social3,
    account_link: "https://www.yelp.com/biz/montgomery-jewelers-huntington-beach",
  },
  {
    account_alt: "Linkedin",
    account_icon: linkedinIcon,
    account_img: Social3,
    account_link: "https://www.linkedin.com/company/montgomery-jewelers",
  },
];

export const InvoiceAddress = () => {
  // <===---Invoice_Address  //
  return (
    <>
      <h4 className="mb-2">20 W 47th St, Suite 601</h4>
      <h4 className="mb-0"> New York, NY 10036</h4>
    </>
  );
};

//--------------------------------------------------Api header data
export const postHeader = {
  // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const onTop = () => {
  window.scrollTo(0, 0);
};

export const ProtectedRoutes = () => {
  const user = useSelector((state) => state.persistedReducer.home.userData);
  return user?.isLogin ? <Outlet /> : <Navigate to="/" />;
};
//---------------------------------------------------Ring builder
export const setSteps = (check) => {
  const diamonddata = JSON.parse(localStorage.getItem("bw-diamonddata"))
    ? JSON.parse(localStorage.getItem("bw-diamonddata"))
    : null;
  const settingdata = JSON.parse(localStorage.getItem("bw-settingdata"))
    ? JSON.parse(localStorage.getItem("bw-settingdata"))
    : null;
  const gemstonedata = JSON.parse(localStorage.getItem("bw-gemstonedata"))
    ? JSON.parse(localStorage.getItem("bw-gemstonedata"))
    : null;
  const fancycolordata = JSON.parse(localStorage.getItem("bw-fancycolordata"))
    ? JSON.parse(localStorage.getItem("bw-fancycolordata"))
    : null;
  var arr;
  if (check == 0) {
    if (settingdata == null) {
      arr = [0, 3];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    } else if (settingdata != null) {
      arr = [3, 0];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    }
  } else if (check == 1) {
    if (settingdata == null) {
      arr = [1, 3];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    } else if (settingdata != null) {
      arr = [3, 1];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    }
  } else if (check == 2) {
    if (settingdata == null) {
      arr = [2, 3];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    } else if (settingdata != null) {
      arr = [3, 2];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    }
  } else if (check == 3) {
    if (diamonddata == null) {
      arr = [3, 1];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    } else if (diamonddata != null) {
      arr = [1, 3];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    }
  } else if (check == 4) {
    if (gemstonedata == null) {
      arr = [3, 2];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    } else if (gemstonedata != null) {
      arr = [2, 3];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    }
  } else if (check == 5) {
    if (fancycolordata == null) {
      arr = [3, 0];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    } else if (fancycolordata != null) {
      arr = [0, 3];
      sessionStorage.setItem("bw-step", JSON.stringify(arr));
    }
  }
};

//---------------------------------------------------stud builder
export const setStudSteps = (check) => {
  const diamonddata = JSON.parse(localStorage.getItem("bw-stud-diamonddata"))
    ? JSON.parse(localStorage.getItem("bw-stud-diamonddata"))
    : null;
  const settingdata = JSON.parse(localStorage.getItem("bw-stud-settingdata"))
    ? JSON.parse(localStorage.getItem("bw-stud-settingdata"))
    : null;
  const gemstonedata = JSON.parse(localStorage.getItem("bw-stud-gemstonedata"))
    ? JSON.parse(localStorage.getItem("bw-stud-gemstonedata"))
    : null;
  const fancycolordata = JSON.parse(
    localStorage.getItem("bw-stud-fancycolordata")
  )
    ? JSON.parse(localStorage.getItem("bw-stud-fancycolordata"))
    : null;
  var arr;
  if (check == 0) {
    if (settingdata == null) {
      arr = [0, 3];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    } else if (settingdata != null) {
      arr = [3, 0];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    }
  } else if (check == 1) {
    if (settingdata == null) {
      arr = [1, 3];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    } else if (settingdata != null) {
      arr = [3, 1];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    }
  } else if (check == 2) {
    if (settingdata == null) {
      arr = [2, 3];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    } else if (settingdata != null) {
      arr = [3, 2];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    }
  } else if (check == 3) {
    if (diamonddata == null) {
      arr = [3, 1];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    } else if (diamonddata != null) {
      arr = [1, 3];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    }
  } else if (check == 4) {
    if (gemstonedata == null) {
      arr = [3, 2];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    } else if (gemstonedata != null) {
      arr = [2, 3];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    }
  } else if (check == 5) {
    if (fancycolordata == null) {
      arr = [3, 0];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    } else if (fancycolordata != null) {
      arr = [0, 3];
      sessionStorage.setItem("bw-stud-step", JSON.stringify(arr));
    }
  }
};

//------------------- Image error------------------------

export const ErrorImg = (dia_shape, id, type) => {
  if (dia_shape == "Round") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/round.jpg";
  } else if (dia_shape == "Princess") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/princess.jpg";
  } else if (dia_shape == "Cushion") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/cushion.jpg";
  } else if (dia_shape == "Emerald") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/emerald.jpg";
  } else if (dia_shape == "Oval") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/oval.jpg";
  } else if (dia_shape == "Radiant") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/radiant.jpg";
  } else if (dia_shape == "Asscher") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/asscher.jpg";
  } else if (dia_shape == "Marquise") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/marquise.jpg";
  } else if (dia_shape == "Heart") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/heart.jpg";
  } else if (dia_shape == "Pear") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/pear.jpg";
  } else if (dia_shape == "Gemstone") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/gemstone.png";
  } else if (dia_shape == "Fancy") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/fancy_diamond.png";
  } else if (dia_shape === "none") {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/image-not-found.png";
  } else {
    var img = "https://dl2vs6wk2ewna.cloudfront.net/shapes/diamond.png";
  }

  if (type == "detail" || type == "Complete") {
    if (type == "Complete") {
      var imgsrc = document
        .getElementsByClassName("image-gallery-thumbnail-image")[1]
        .getAttribute("src");
      var image = new Image();
      image.src = imgsrc;
      image.onerror = () => {
        document.getElementsByClassName(
          "image-gallery-thumbnail-image"
        )[1].src = img;
      };
    } else {
      var imgsrc = document
        .getElementsByClassName("image-gallery-thumbnail")[0]
        .getElementsByTagName("img")[0]
        .getAttribute("src");
      var image = new Image();
      image.src = imgsrc;
      image.onerror = () => {
        document.getElementsByClassName("image-gallery-thumbnail-image")[
          type == "Complete" ? 1 : 0
        ].src = img;
        document
          .getElementsByClassName("image-to-magnify")[0]
          .getElementsByTagName("img")[0].src = img;
      };
      image.onload = () => {
        document
          .getElementsByClassName("image-to-magnify")[0]
          .getElementsByTagName("img")[0].src = imgsrc;
      };
    }
    // image.onload = () => {
    //   document.getElementsByClassName("image-to-magnify")[0].getElementsByTagName("img")[0].src = imgsrc;
    // }
  } else {
    console.log("ImageError sku: ", id);
    document.getElementById(id).src = img;
  }
};

export const formatOrAddNumberStrings = (numberString1, numberString2 = null) => {
  // Helper function to convert input (string or number) to a float
  function toNumber(input) {
    if (typeof input === "string") {
      return parseFloat(input.replace(/,/g, ""));
    }
    return parseFloat(input); // If it's already a number, return it as-is
  }

  // Helper function to format a number to two decimal places with commas
  function formatNumber(number) {
    return number.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  // If only one input is passed, format it
  if (numberString2 === null) {
    const number = toNumber(numberString1);
    return formatNumber(number);
  }

  // If two inputs are passed, add them
  const number1 = toNumber(numberString1);
  const number2 = toNumber(numberString2);
  const total = number1 + number2;
  // Format and return the result
  return formatNumber(total);
};